import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=b37d6cae&scoped=true&"
import script from "./ResetView.vue?vue&type=script&lang=js&"
export * from "./ResetView.vue?vue&type=script&lang=js&"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=b37d6cae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37d6cae",
  null
  
)

export default component.exports